import qa from './qa.json';
import dev from './dev.json';
import prod from './prod.json';
import az from './az.json';

interface IConfig {
  dataopsOAuthClient: {
    clientId: string;
    authorizationEndpoint: string;
    tokenEndpoint: string;
    redirectUri: string;
    scope: string;
    decodeToken: boolean;
    redirectCallbackPath: string;
    autoLogin: boolean;
  };
  dataopsliveBaseUrl: string;
  dataopsGraphQlApiEndpoint: string;
  recaptchaSiteKey: string;
  posthog: {
    apiKey: string;
    host: string;
  };
}

export function getConfig(): IConfig {
  const posthogConfig = {
    apiKey: process.env.REACT_APP_PUBLIC_POSTHOG_KEY || '',
    host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
  };

  switch (process.env.REACT_APP_ENV) {
    case 'dev':
      return {
        ...dev,
        recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
        posthog: posthogConfig,
      };
    case 'qa':
      return {
        ...qa,
        recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
        posthog: posthogConfig,
      };
    case 'production':
      return {
        ...prod,
        recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
        posthog: posthogConfig,
      };
    case 'az':
      return {
        ...az,
        recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
        posthog: posthogConfig,
      };
    default:
      return {
        ...dev,
        recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
        posthog: posthogConfig,
      };
  }
}
